import _extends from "@babel/runtime/helpers/esm/extends";
import { Tooltip } from '../Tooltip';
import { Icon } from '../Icon';
import { useTheme } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
//TODO: Use this common component in every component with a help icon tooltip
export function HelpIconWithTooltip(_ref) {
  var sx = _ref.sx,
    tooltipArrow = _ref.tooltipArrow,
    tooltipDescription = _ref.tooltipDescription,
    tooltipLabel = _ref.tooltipLabel,
    tooltipMaxWidth = _ref.tooltipMaxWidth,
    tooltipPlacement = _ref.tooltipPlacement,
    tooltipProps = _ref.tooltipProps,
    tooltipVariant = _ref.tooltipVariant,
    tooltipWidth = _ref.tooltipWidth;
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Tooltip, _extends({
    arrow: tooltipArrow,
    description: tooltipDescription,
    label: tooltipLabel,
    maxWidth: tooltipMaxWidth,
    placement: tooltipPlacement,
    variant: tooltipVariant,
    width: tooltipWidth
  }, tooltipProps, {
    "data-element": "Tooltip",
    "data-component": "HelpIconWithTooltip",
    "data-source-file": "HelpIconWithTooltip.tsx",
    children: /*#__PURE__*/_jsx(Icon, {
      iconId: "HelpCircle",
      size: 16,
      sx: _extends({
        '&:hover': {
          color: theme.palette.gray[500]
        },
        color: theme.palette.gray[400]
      }, sx),
      "data-element": "Icon",
      "data-source-file": "HelpIconWithTooltip.tsx"
    })
  }));
}